import PropTypes from 'prop-types';
import React from 'react';
import ResponsiveVideo from '../../../Elements/ResponsiveVideo/ResponsiveVideo';
import { videoTypes } from '../../../../utilities/ui_utilities';
import './VideoPlayer.scss';
import { SnowplowImpressionTracker } from '../../../Analytics/Snowplow/SnowplowImpressionViewTracker';
import YoutubePlayerIFrameAPI from '../../../Elements/YoutubePlayerIFrameAPI/YoutubePlayerIFrameAPI';

export default class VideoPlayer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.divRef = React.createRef();
        this.hasIntersected = false;
        this.lastSearchId = undefined;
        this.observer = null;
        this.isInViewport = false;
    }

    componentDidMount() {
        this.observer = new IntersectionObserver((entries) => {
            const { impressionMetric, videoType, searchId } = this.props;
            if (!impressionMetric) return;
            entries.forEach((entry) => {
                if (
                    entry.isIntersecting &&
                    (!this.hasIntersected || searchId !== this.lastSearchId)
                ) {
                    SnowplowImpressionTracker({
                        ...impressionMetric,
                        searchId,
                        providerName: videoType,
                    });
                    this.hasIntersected = true;
                    this.lastSearchId = searchId;
                }
                this.isInViewport = entry.isIntersecting; // Update the viewport status
            });
        });

        this.observer.observe(this.divRef.current);
    }

    componentDidUpdate(prevProps) {
        const { impressionMetric, videoType, searchId } = this.props;
        if (!impressionMetric) return;
        if (this.props.searchId !== prevProps.searchId && this.isInViewport) {
            SnowplowImpressionTracker({
                ...impressionMetric,
                searchId,
                providerName: videoType,
            });
            this.hasIntersected = true;
            this.lastSearchId = searchId;
        }
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    renderYouTubeVideo() {
        const { autoPlay, videoSrc, videoPlayMetric } = this.props;
        if (!videoSrc) return null;
        return (
            <YoutubePlayerIFrameAPI
                autoPlay={autoPlay}
                videoSrc={videoSrc}
                videoPlayMetric={videoPlayMetric}
            />
        );
    }

    renderCloundinaryVideo() {
        const {
            videoSrc,
            autoPlay,
            videoPlayMetric,
            responsiveVideoProps = {},
        } = this.props;
        if (!videoSrc) return null;
        return (
            <ResponsiveVideo
                {...responsiveVideoProps}
                cloudinaryID={videoSrc}
                enableAutoResizing={false}
                autoPlay={autoPlay}
                videoPlayMetric={videoPlayMetric}
            />
        );
    }

    render() {
        const iframeClass =
            this.props.videoType === videoTypes.YOUTUBE
                ? 'iFrame-container'
                : '';
        return (
            <div
                ref={this.divRef}
                className={`component-CompanyPages-Sections-VideoPlayer ${iframeClass} ${
                    this.props.fullWidth ? 'full-width' : ''
                }`}
            >
                {this.props.videoType === videoTypes.YOUTUBE
                    ? this.renderYouTubeVideo()
                    : this.renderCloundinaryVideo()}
            </div>
        );
    }
}

VideoPlayer.propTypes = {
    videoType: PropTypes.oneOf([videoTypes.CLOUDINARY, videoTypes.YOUTUBE])
        .isRequired,
    videoSrc: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
    autoPlay: PropTypes.bool,
    responsiveVideoProps: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number,
        emitMetric: PropTypes.bool,
    }),
    impressionMetric: PropTypes.objectOf(PropTypes.string),
    videoPlayMetric: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    searchId: PropTypes.string,
};

VideoPlayer.defaultProps = {
    fullWidth: false,
    autoPlay: false,
    responsiveVideoProps: {
        width: 1600,
        height: 900,
    },
    impressionMetric: null,
    videoPlayMetric: null,
    searchId: null,
};
